import {Box, Typography, Link as LinkMui} from '@mui/material'
import { Link as LinkRouter } from "react-router-dom"
import {COMMON_URLS} from '../constants/constants'

export default function MainFooter() {
  return (
    <Box width="100%" py={1} textAlign="center"
      sx={{ bgcolor: 'grey.900',color: 'white', position:"relative" }}
    >
      <Typography variant="caption" sx={{ display: 'block',fontWeight: 'medium', fontSize: 15 }}>
        <LinkRouter to={COMMON_URLS.FAQ.URL} style={{color:"white",textDecoration:"none"}}>
        よくある質問（FAQ）はこちら
        </LinkRouter>
      </Typography>
      <Typography variant="caption">
        {"Copyright © "}
        {new Date().getFullYear()}{" "}
        <LinkMui color="inherit" href="https://www.robocip.or.jp/" underline="none" target="_blank">
          ROBOCIP
        </LinkMui>{" All rights reserved."}
      </Typography>
      <Typography variant="caption" sx={{position:"absolute",right:"5px",bottom:0, color: 'grey.900'}}>
        {String(process.env.REACT_APP_VERSION)}
      </Typography>
    </Box>
  )
}